/**
 * @typedef {Object} CarStorage.CarEntity
 * @property {Number} carId
 * @property {Date} date
 */

class CarStorage {
    constructor() {
        CarStorage._verifyBrowserCompatibility();
    }

    /**
     * @returns {string}
     */
    storageKey() {
        return 'carStorage';
    }

    static _verifyBrowserCompatibility() {
        if (typeof(Storage) === 'undefined') {
            throw "Keine Unterstützung für window.localStorage";
        }
    }

    /**
     * @returns {null|Object<CarStorage.CarEntity>}
     */
    _getStorage() {
        let storageString = window.localStorage.getItem(this.storageKey());
        if (!storageString) {
            return null;
        }

        return JSON.parse(storageString);
    }

    /**
     * @param {Object<CarStorage.CarEntity>} list
     */
    _saveStorage(list) {
        window.localStorage.setItem(this.storageKey(), JSON.stringify(list));
    }

    /**
     * @returns {Object<CarStorage.CarEntity>}
     */
    findAll() {
        return this._getStorage() || {};
    }

    /**
     * @param {string} id
     * @returns {CarStorage}
     */
    addCar(id) {
        let storage = this._getStorage() || {};

        storage[id] = {
            carId: id,
            date: new Date()
        };

        this._saveStorage(storage);

        return this;
    }

    /**
     * @param {string} id
     * @returns {CarStorage}
     */
    removeCar(id) {
        let storage = this._getStorage() || {};

        delete storage[id];
        this._saveStorage(storage);

        return this;
    }

    /**
     * @returns {number}
     */
    count() {
        let storage = this._getStorage() || {};

        return Object.keys(storage).length;
    }
}
